import Input from '../../components/Input';
import Select from '../../components/Select';
import Checkbox from '../../components/Checkbox';
import translateLabel from '../../helpers/translateLabel';
import mandatoryFields, { ALL_WEBHOOK_EVENT_TYPES } from '../../configs/webhooks';

const eventTypeOptions = ALL_WEBHOOK_EVENT_TYPES.map((t) => ({ label: t, value: t }));

export default function getFormInput({ name, register, control, error, disabled, index }) {
    if (name === 'event_types') {
        return (
            <Select
                key={index}
                label={translateLabel(name)}
                name="event_types"
                options={eventTypeOptions}
                control={control}
                error={error}
                disabled={disabled}
                multiple={true}
                isRequired={false}
            />
        );
    }
    if (name === 'is_active') {
        return (
            <div key={index} style={{ margin: '12px 0' }}>
                <label style={{ display: 'block', marginBottom: 6 }}>{translateLabel(name)}</label>
                <Checkbox
                    text={translateLabel(name)}
                    {...register(name)}
                    disabled={disabled}
                />
            </div>
        );
    }
    return (
        <Input
            key={index}
            label={translateLabel(name)}
            name={name}
            {...register(name, {
                required: mandatoryFields.find((field) => (field === name ? true : false)),
            })}
            error={error}
            disabled={disabled}
        />
    );
}
